import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodeIssues = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 37,
	height: 36,
	viewBox: "0 0 37 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.5767 24.7952C18.412 24.7952 18.2754 24.6506 18.2754 24.4738V22.5452C18.2754 22.3684 18.412 22.2238 18.5767 22.2238H26.0097C26.1745 22.2238 26.3111 22.3684 26.3111 22.5452V24.4738C26.3111 24.6506 26.1745 24.7952 26.0097 24.7952H18.5767ZM18.1588 18.2501L10.4446 24.7189C10.2356 24.8956 9.91821 24.747 9.91821 24.4738V21.9546C9.91886 21.9077 9.9296 21.8616 9.94971 21.8193C9.96982 21.777 9.99882 21.7396 10.0347 21.7095L14.4463 18.005L10.0347 14.3006C9.95839 14.2403 9.91821 14.1519 9.91821 14.0555V11.5363C9.91788 11.4751 9.93509 11.4152 9.96781 11.3636C10.0005 11.3119 10.0474 11.2708 10.1028 11.245C10.1582 11.2191 10.2199 11.2098 10.2804 11.218C10.341 11.2262 10.398 11.2516 10.4446 11.2912L18.1588 17.7559C18.3115 17.8845 18.3115 18.1215 18.1588 18.2501ZM3.32893 1.93359H32.9004C33.6115 1.93359 34.1861 2.50815 34.1861 3.21931V32.7907C34.1861 33.5019 33.6115 34.0765 32.9004 34.0765H3.32893C2.61777 34.0765 2.04321 33.5019 2.04321 32.7907V3.21931C2.04321 2.50815 2.61777 1.93359 3.32893 1.93359ZM4.93607 31.1836H31.2932V8.70459H4.93607V31.1836Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCodeIssues);
export { ForwardRef as ReactComponent };
